.btn-actions{--bs-btn-disabled-bg: white;--bs-btn-disabled-color: #333;--bs-btn-disabled-opacity: .5}:host{display:flex;flex-direction:row;gap:8px;position:relative}
/*# sourceMappingURL=saved-view-actions.component-JGO6JRSX.css.map */
